<template>
  <div 
    @click.prevent="urlHandler.redirectAndScroll(`/course/${course.uuid}`)"
    class="group flex flex-col sm:flex-row gap-5 p-4 border-b border-iron hover:bg-surface-50 cursor-pointer transition-colors"
  >
    <div class="w-full sm:w-48 md:w-64 aspect-video bg-iron rounded overflow-hidden flex-shrink-0 shadow-sm border border-iron">
      <img 
        :src="course.getCoursePhoto ? course.getCoursePhoto() : ''" 
        :alt="course.title"
        class="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
        loading="lazy"
      />
    </div>

    <div class="flex-grow flex flex-col justify-between">
      <div>
        <div class="flex flex-wrap items-start justify-between gap-2 mb-1">
          <h2 class="font-bold text-lg text-secondary leading-tight group-hover:text-blue-600 transition-colors">
            {{ course.title }}
          </h2>
          <span class="hidden sm:block font-bold text-xl text-secondary whitespace-nowrap">
            R$ {{ course.price }}
          </span>
        </div>

        <p class="text-sm text-gray-600 line-clamp-2 mb-2 leading-relaxed">
          {{ course.headline || course.description }}
        </p>

        <p class="text-xs text-gray-400 mb-2 font-medium">
          {{ capitalizeWords(course.authorName || instructor?.name || '') }}
        </p>

        <div class="flex items-center gap-1.5 mb-2 text-sm" v-if="course.rating != null">
          <span class="text-dark-passion-fruit font-bold">{{ course.rating || '0.0' }}</span>
          <div class="flex text-passion-fruit text-[11px] gap-0.5">
            <i 
              v-for="star in 5" 
              :key="star"
              :class="star <= Math.round(course.rating || 0) ? 'pi pi-star-fill' : 'pi pi-star'"
            ></i>
          </div>
          <span class="text-xs text-gray-400 font-mono">({{ course.reviewsCount || 0 }} {{ translate('avaliations') }} )</span>
        </div>
      </div>

      <div class="flex flex-wrap items-center gap-3 mt-2 sm:mt-0">
        <span class="sm:hidden font-bold text-lg text-secondary">
          R$ {{ course.price }}
        </span>

        <div v-if="course.getBuysNumber && course.getBuysNumber() > 10" class="inline-block bg-passion-fruit text-[10px] font-bold px-2 py-1 uppercase tracking-wider text-secondary">
          {{ course.getBuysNumber(true) }} {{ translate('sales', 'upper') }}
        </div>
        
        <div v-if="course.rating >= 4.7" class="inline-block bg-purple-suit-forced-light text-[10px] font-bold px-2 py-1 uppercase tracking-wider text-purple-900 rounded-sm">
          {{ translate('highest rating', 'ucfirst') }}
        </div>

        <div class="text-xs text-gray-400 font-mono flex gap-2">
          <span>{{ course.totalHours || '8.5' }} {{ translate('total hours') }}</span>
          <span>•</span>
          <span>{{ course.lessonsCount || '80' }} {{ translate('videos') }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { defineProps } from 'vue';
import { capitalizeWords } from '@/composables/textUtils';
import urlHandler from '@/composables/urlHandler';
import { translate } from '@/composables/translate';

defineProps({
  course: {
    type: Object,
    required: true,
    default: () => ({})
  },
  instructor: {
    type: Object,
    required: false,
    default: null
  }
});
</script>